export const PRODUCTS = 'products';
export const PASSES = 'passes';
export const BASE_PRODUCTS_PATH = `/${PRODUCTS}`;
export const BASE_PASSES_PATH = `/${PASSES}`;
export const PASSES_LIST_PATH = BASE_PASSES_PATH;

export const getPassesListPath = (): string => PASSES_LIST_PATH;
export const PRODUCT_PROFILE = 'product-profile';
export const GENERAL_SETTINGS = 'general-settings';
export const PRICING = 'pricing';

const getProductPath = (productId: number) =>
	productId ? `${BASE_PRODUCTS_PATH}/${productId}/${PRODUCT_PROFILE}` : `${BASE_PRODUCTS_PATH}/${PRODUCT_PROFILE}`;

const getPassPath = (productId?: number) =>
	productId ? `${BASE_PASSES_PATH}/${productId}/${PRODUCT_PROFILE}` : `${BASE_PASSES_PATH}/${PRODUCT_PROFILE}`;

export const getProductProfilePath = (productId?: number) => {
	return `${getProductPath(productId)}/${GENERAL_SETTINGS}`;
};

export const getPassProfilePath = (id?: number) => `${getPassPath(id)}/${GENERAL_SETTINGS}`;

export const getProductPricingPath = (productId: number) => `${getProductPath(productId)}/${PRICING}`;

export const getPassPricingPath = (id: number) => `${getPassPath(id)}/${PRICING}`;

export const getEditRentalProductPathById = (productId: number) => `${getProductProfilePath(productId)}`;

export const getEditPassPathById = (id: number) => `${getPassProfilePath(id)}`;
